<template>
  <el-header class="header">
    <button class="btn" @click="toggleCollapse">
      <em class="el-icon-menu"></em>
    </button>
    <el-tooltip effect="dark" content="刷新" placement="bottom-start">
      <button class="btn" @click="reload">
        <em class="el-icon-refresh"></em>
      </button>
    </el-tooltip>
    <span class="user">
      {{ $store.state.Config.user }}
    </span>
    <el-button size="small" class="logout" type="danger" @click="logout">{{
      $t("app.logout")
    }}</el-button>
  </el-header>
</template>
<script>
import { loginBackstage } from "@/api/login";
import { getBaseInfo } from "@/api/oldStudent";
import * as newStu from "@/api/newStudent";
export default {
  name: "Header",
  inject: ["reload"],
  props: {
    isPhone: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$store.state.Config.menuCollapse = this.isPhone;
    let userType = localStorage.getItem("studentType");
    if (userType === null || userType === undefined) {
      //用戶類型緩存丟失，跳轉到登錄頁
      this.$router.push({ path: "/" });
      return;
    }
    if (this.$store.state.Config.studentType === "new") {
      newStu
        .getBaseInfo({
          applicationCode: this.$store.state.Config.applicationId,
          idNo: this.$store.state.Config.cardId,
        })
        .then((res) => {
          this.$store.commit("Config/set_user", res.data.LastName);
        });
    } else if (this.$store.state.Config.studentType === "old") {
      getBaseInfo().then((res) => {
        this.$store.commit("Config/set_user", res.data.Name);
      });
    } else if (this.$store.state.Config.studentType === "admin") {
      loginBackstage().then((res) => {
        this.$store.commit("Config/set_user", res.data.message);
        this.$store.commit("Config/jwtToken", res.data.data);
        if(res.data.data) {
          localStorage.setItem("admin_jwtToken", res.data.data);
          localStorage.removeItem("jwtToken");
        }
      });
    }
  },
  methods: {
    toggleCollapse() {
      this.$store.commit(
        "Config/set_menuCollapse",
        !this.$store.state.Config.menuCollapse
      );
    },
    logout() {
      if (this.$store.state.oidcStore.id_token) {
        this.$confirm("", {
          title: "",
          message: this.$t("app.logoutMSG"),
          showCancelButton: true,
          confirmButtonText: this.$t("app.confirm"),
          cancelButtonText: this.$t("app.cancel"),
          type: "warning",
        }).then(() => {
          this.$store.dispatch("oidcStore/signOutOidc");
        });
        return;
      }
      // this.$router.push({ path: "/" });
      this.$router.replace('/')

    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #aaa;
  box-shadow: 0px 0px 4px #aaa;
  background-color: #ffffff;
  .btn {
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    margin-right: 20px;
    background-color:#119F7B;// #409eff;
    color: white;
    outline: none;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .user {
    position: absolute;
    display: inline-block;
    height: 60px;
    padding: 0 10px;
    right: 80px;
    // cursor: pointer;
    .arrow {
      margin-left: 10px;
    }
    // &:hover {
    //   background-color: rgba($color: #aaa, $alpha: 0.4);
    //   .arrow {
    //     transform: rotate(180deg);
    //   }
    //   .logout {
    //     display: block;
    //   }
    // }
  }

  .logout {
    position: absolute;
    top: 13px;
    right: 10px;
    text-align: center;
    &:hover {
      background-color: red;
      .arrow {
        transform: rotate(180deg);
      }
      .logout {
        display: block;
      }
    }
  }
}
</style>
